import api from "./api.service";

export const customerRecoveryService = {
  sendRecoveryCode: async (
    email: string
  ): Promise<{ success: boolean; error?: string }> => {
    try {
      const payload = {
        email,
      };

      const response = await api.post(
        "/send-customer-password-recovery-code",
        payload
      );

      if (response.data.statusCode === 200) {
        return { success: true };
      } else {
        return {
          success: false,
          error: response.data.response.data.errorDetail,
        };
      }
    } catch (error: any) {
      console.error("Error sending recovery code:", error);
      return {
        success: false,
        error: error.response?.data?.errorDetail || error.message,
      };
    }
  },

  verifyRecoveryCode: async (
    email: string,
    verificationCode: string
  ): Promise<{ success: boolean; error?: string }> => {
    try {
      const payload = {
        email,
        verificationCode,
      };

      const response = await api.post(
        "/verify-customer-recovery-code",
        payload
      );

      if (response.data.statusCode === 200) {
        return { success: true };
      } else {
        return {
          success: false,
          error: response.data.response.data.errorDetail,
        };
      }
    } catch (error: any) {
      console.error("Error verifying recovery code:", error);
      return {
        success: false,
        error: error.response?.data?.errorDetail || error.message,
      };
    }
  },

  resetPassword: async (
    email: string,
    newPassword: string
  ): Promise<{ success: boolean; error?: string }> => {
    try {
      const payload = {
        email,
        newPassword,
      };

      const response = await api.post(
        "/customer-recovery-password",
        payload
      );

      if (response.data.statusCode === 200) {
        return { success: true };
      } else {
        return {
          success: false,
          error: response.data.response.data.errorDetail,
        };
      }
    } catch (error: any) {
      console.error("Error resetting password:", error);
      return {
        success: false,
        error: error.response?.data?.errorDetail || error.message,
      };
    }
  },
};
